export default __webpack_public_path__ + "static/media/american-school-of-doha.d3ddc569.png";